import React from "react";
import PropTypes from "prop-types";
import NeoCard from "../../../../../components/Common/NeoCard";
import NeoTable from "../../../../../components/Common/NeoTable";
import NeoBadge from "../../../../../components/Common/NeoBadge";

const ACTION_COLORS = {
    get_tenant_detail: "secondary",
    list_tenants: "secondary",
    create_tenant: "success",
    tenant_profile_updated: "warning",
    subscription_plan_changed: "info",
    trial_period_updated: "warning",
    subscription_cancelled: "danger",
    tenant_blocked: "danger",
    tenant_temporary_liberation: "warning",
    admin_impersonation: "accent",
    payment_registered_manual: "success",
    invoice_created_manual: "info",
    onboarding_step_updated: "secondary",
    support_ticket_created: "info",
    support_ticket_resolved: "success",
};

const DetailLogs = ({ logs }) => {
    const columns = [
        {
            key: "date",
            label: "Data / Hora",
            width: "18%",
            render: (row) => (
                <div className="d-flex align-items-center font-size-12 fw-bold text-muted">
                    <i className="mdi mdi-clock-outline me-1 text-muted" />
                    {row.date || "—"}
                </div>
            ),
        },
        {
            key: "user",
            label: "Autor",
            width: "20%",
            render: (row) => (
                <span className="fw-semibold text-dark font-size-13">
                    {row.user || "—"}
                </span>
            ),
        },
        {
            key: "action",
            label: "Ação",
            width: "18%",
            render: (row) => (
                <NeoBadge color={ACTION_COLORS[row.action] || "accent"}>
                    {row.action || "—"}
                </NeoBadge>
            ),
        },
        {
            key: "desc",
            label: "Descrição",
            width: "44%",
            render: (row) => (
                <span className="text-muted font-size-12 text-wrap" style={{ lineHeight: "1.3" }}>
                    {row.desc || "—"}
                </span>
            ),
        },
    ];

    return (
        <NeoCard
            title="Logs de Auditoria Administrativa"
            subtitle={`${logs.length} registro${logs.length !== 1 ? "s" : ""} encontrado${logs.length !== 1 ? "s" : ""}`}
            thinBorder={true}
            bodyClassName="p-0"
        >
            <NeoTable
                columns={columns}
                data={logs}
                keyField="id"
                defaultItemsPerPage={20}
                itemsPerPageOptions={[20, 50]}
                emptyMessage="Nenhum log de auditoria registrado"
                emptySubMessage="As ações dos administradores sobre esta academia aparecerão aqui."
            />
        </NeoCard>
    );
};

DetailLogs.propTypes = {
    logs: PropTypes.array.isRequired
};

export default DetailLogs;
